import { CheckBox } from "devextreme-react";
import { Form, GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getApiParams } from "../../redux/auth";
import { BodyType, createRequest } from "../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga";
import { getLocalized } from "../../redux/localization";
import { AdminCurrencies, AdminPeriodType, CreateAdminPackage } from "./type";

const createAdminPackages = forwardRef<any, { data: CreateAdminPackage }>((
    { data }, ref
) => {

    const localize = useSelector(getLocalized);
    const { token, lang } = useSelector(getApiParams);
    const [currency, setCurrency] = useState<AdminCurrencies[]>([]);
    const [periodTypes, setPeriodTypes] = useState<AdminPeriodType[]>([]);

    const getCurrencies = useCallback((async () => {
        const response: ApiResponse<AdminCurrencies[]> = await createRequest({
            method: "GET",
            url: "/api/admin/adminpackages/get-currecies",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setCurrency(response.Result)
        }
    }), [token, lang])

    const getPeriodTypes = useCallback((async () => {
        const response: ApiResponse<AdminPeriodType[]> = await createRequest({
            method: "GET",
            url: "/api/admin/adminpackages/get-period-types",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setPeriodTypes(response.Result)
        }
    }), [token, lang])

    useEffect(() => {
        getCurrencies()
        getPeriodTypes()
    }, [getCurrencies, getPeriodTypes])


    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem>
            <SimpleItem
                dataField={"Name"}
                editorType={"dxTextBox"}
                label={{
                    text: localize.getString("name")
                }}

            >

            </SimpleItem>
            <SimpleItem
                dataField={`CurrencyId`}
                editorType="dxLookup"
                label={{ text: localize.getString("currency") }}
                editorOptions={
                    {
                        searchEnabled: true,
                        items: currency,
                        displayExpr: "Code",
                        valueExpr: "Id",
                        onValueChanged: (e: any) => {
                            data.CurrencyId = e.value
                        }
                    }
                }
            >
            </SimpleItem>
            <SimpleItem
                dataField={`PeriodTypeId`}
                editorType="dxLookup"
                label={{ text: localize.getString("periodtypename") }}
                editorOptions={
                    {
                        searchEnabled: true,
                        items: periodTypes,
                        displayExpr: "Name",
                        valueExpr: "Id",
                        onValueChanged: (e: any) => {
                            data.PeriodTypeId = e.value
                        }
                    }
                }
            >
            </SimpleItem>
            <SimpleItem
                dataField={"LocationCount"}
                editorType={"dxNumberBox"}
                label={{
                    text: localize.getString("locationCount")
                }}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"ProductCount"}
                editorType={"dxNumberBox"}
                label={{
                    text: localize.getString("productCount")
                }}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"Price"}
                editorType={"dxNumberBox"}
                label={{
                    text: localize.getString("price")
                }}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"Default"}
                editorType={"dxCheckBox"}
                label={{
                    text: localize.getString("default")
                }}
                render={(item: any) => {
                    return <CheckBox
                        defaultValue={data.Default}
                        onValueChanged={(e: any) => {

                            data.Default = e.value
                        }}
                    ></CheckBox>;
                }}
            >
            </SimpleItem>
        </GroupItem>
    </Form>
})

export default createAdminPackages